import React from 'react'

export default function EditPackingList() {
  return (
    <div>EditPackingList</div>
  )
}
